import { Injectable } from '@angular/core';
import { toGroupchatType } from '@shared/ProjectKeyValStore';
import { BotService } from './bot.service';
import { GroupchatChannelRegistryService } from './groupchat-channel-registry.service';
import { ProjectKeyValAdminService } from './project-key-val-admin.service';

@Injectable({
  providedIn: 'root'
})
export class BotGroupchatService {

  constructor(
    private projectKeyVal: ProjectKeyValAdminService,
    private botService: BotService,
    private channelRegistry: GroupchatChannelRegistryService
  ) { }

  private getBotName(): string {
    return this.botService.botConfig?.name ?? 'Unknown Bot';
  }

  public async send(message: string, channel: string): Promise<void> {
    const value = this.getBotName() + ': ' + message;
    await this.projectKeyVal.unique('msg', value, toGroupchatType(channel));
  }

  public async read(channel: string): Promise<string> {
    const entries = await this.projectKeyVal.getByType(toGroupchatType(channel));
    return entries.map(e => e.value).join('\n\n');
  }

  public async delete(id: string): Promise<void> {
    const entries = await this.projectKeyVal.getByType(toGroupchatType(id));
    for (const entry of entries) {
      await this.projectKeyVal.deleteKeyValEntry(entry.key, entry.type);
    }
    this.channelRegistry.removeChannel(id);
  }
}
